import { render } from "./GeneralModalTab.vue?vue&type=template&id=4e364a8e&scoped=true"
import script from "./GeneralModalTab.vue?vue&type=script&lang=js"
export * from "./GeneralModalTab.vue?vue&type=script&lang=js"

import "./GeneralModalTab.vue?vue&type=style&index=0&id=4e364a8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e364a8e"]])

export default __exports__